<template>
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1254_7236)">
      <path
        d="M9.5 1.75H28C28.5304 1.75 29.0391 1.96071 29.4142 2.33579C29.7893 2.71086 30 3.21957 30 3.75V27.25C30 27.7804 29.7893 28.2891 29.4142 28.6642C29.0391 29.0393 28.5304 29.25 28 29.25H9.5C8.96957 29.25 8.46086 29.0393 8.08579 28.6642C7.71071 28.2891 7.5 27.7804 7.5 27.25V3.75C7.5 3.21957 7.71071 2.71086 8.08579 2.33579C8.46086 1.96071 8.96957 1.75 9.5 1.75Z"
        fill="#EDEEF0"
      />
      <path
        d="M4.5 1.75H25.5C26.0304 1.75 26.5391 1.96071 26.9142 2.33579C27.2893 2.71086 27.5 3.21957 27.5 3.75V27.25C27.5 27.7804 27.2893 28.2891 26.9142 28.6642C26.5391 29.0393 26.0304 29.25 25.5 29.25H4.5C3.96957 29.25 3.46086 29.0393 3.08579 28.6642C2.71071 28.2891 2.5 27.7804 2.5 27.25V3.75C2.5 3.21957 2.71071 2.71086 3.08579 2.33579C3.46086 1.96071 3.96957 1.75 4.5 1.75Z"
        fill="#535456"
      />
      <path
        d="M9.75 3H25.25C25.9167 3 26.25 3.33333 26.25 4V27C26.25 27.6667 25.9167 28 25.25 28H9.75C9.08333 28 8.75 27.6667 8.75 27V4C8.75 3.33333 9.08333 3 9.75 3Z"
        fill="white"
      />
      <path
        d="M17.5 13.605C15.69 13.605 14.2237 12.0713 14.2237 10.1775C14.2237 8.285 15.69 6.75 17.5 6.75C19.31 6.75 20.7762 8.285 20.7762 10.1775C20.7762 12.0713 19.31 13.605 17.5 13.605ZM23.75 19.25H11.25C11.25 17.0325 11.25 14.4625 17.5 14.4625C23.75 14.4625 23.75 17.0325 23.75 19.25Z"
        fill="#5BADFF"
      />
      <path
        d="M5.625 8C6.12228 8 6.59919 7.80246 6.95083 7.45083C7.30246 7.09919 7.5 6.62228 7.5 6.125C7.5 5.62772 7.30246 5.15081 6.95083 4.79917C6.59919 4.44754 6.12228 4.25 5.625 4.25C5.12772 4.25 4.65081 4.44754 4.29917 4.79917C3.94754 5.15081 3.75 5.62772 3.75 6.125C3.75 6.62228 3.94754 7.09919 4.29917 7.45083C4.65081 7.80246 5.12772 8 5.625 8ZM5.625 14.25C6.12228 14.25 6.59919 14.0525 6.95083 13.7008C7.30246 13.3492 7.5 12.8723 7.5 12.375C7.5 11.8777 7.30246 11.4008 6.95083 11.0492C6.59919 10.6975 6.12228 10.5 5.625 10.5C5.12772 10.5 4.65081 10.6975 4.29917 11.0492C3.94754 11.4008 3.75 11.8777 3.75 12.375C3.75 12.8723 3.94754 13.3492 4.29917 13.7008C4.65081 14.0525 5.12772 14.25 5.625 14.25ZM5.625 20.5C6.12228 20.5 6.59919 20.3025 6.95083 19.9508C7.30246 19.5992 7.5 19.1223 7.5 18.625C7.5 18.1277 7.30246 17.6508 6.95083 17.2992C6.59919 16.9475 6.12228 16.75 5.625 16.75C5.12772 16.75 4.65081 16.9475 4.29917 17.2992C3.94754 17.6508 3.75 18.1277 3.75 18.625C3.75 19.1223 3.94754 19.5992 4.29917 19.9508C4.65081 20.3025 5.12772 20.5 5.625 20.5ZM5.625 26.75C6.12228 26.75 6.59919 26.5525 6.95083 26.2008C7.30246 25.8492 7.5 25.3723 7.5 24.875C7.5 24.3777 7.30246 23.9008 6.95083 23.5492C6.59919 23.1975 6.12228 23 5.625 23C5.12772 23 4.65081 23.1975 4.29917 23.5492C3.94754 23.9008 3.75 24.3777 3.75 24.875C3.75 25.3723 3.94754 25.8492 4.29917 26.2008C4.65081 26.5525 5.12772 26.75 5.625 26.75Z"
        fill="white"
      />
      <path
        d="M1 4.875H5.25C5.91667 4.875 6.25 5.20833 6.25 5.875V6.375C6.25 7.04167 5.91667 7.375 5.25 7.375H1C0.333333 7.375 0 7.04167 0 6.375V5.875C0 5.20833 0.333333 4.875 1 4.875Z"
        fill="#CACBCC"
      />
      <path
        d="M1 11.125H5.25C5.91667 11.125 6.25 11.4583 6.25 12.125V12.625C6.25 13.2917 5.91667 13.625 5.25 13.625H1C0.333333 13.625 0 13.2917 0 12.625V12.125C0 11.4583 0.333333 11.125 1 11.125Z"
        fill="#CACBCC"
      />
      <path
        d="M1 17.375H5.25C5.91667 17.375 6.25 17.7083 6.25 18.375V18.875C6.25 19.5417 5.91667 19.875 5.25 19.875H1C0.333333 19.875 0 19.5417 0 18.875V18.375C0 17.7083 0.333333 17.375 1 17.375Z"
        fill="#CACBCC"
      />
      <path
        d="M1 23.625H5.25C5.91667 23.625 6.25 23.9583 6.25 24.625V25.125C6.25 25.7917 5.91667 26.125 5.25 26.125H1C0.333333 26.125 0 25.7917 0 25.125V24.625C0 23.9583 0.333333 23.625 1 23.625Z"
        fill="#CACBCC"
      />
      <path
        d="M14.75 21.75H20.25C20.9167 21.75 21.25 22.0833 21.25 22.75V23.25C21.25 23.9167 20.9167 24.25 20.25 24.25H14.75C14.0833 24.25 13.75 23.9167 13.75 23.25V22.75C13.75 22.0833 14.0833 21.75 14.75 21.75Z"
        fill="#EDEEF0"
      />
      <path
        d="M10 1.75H12.5V11.1462C12.5 11.1956 12.4854 11.244 12.4581 11.2851C12.4307 11.3262 12.3917 11.3582 12.3461 11.3772C12.3005 11.3962 12.2503 11.4013 12.2018 11.3918C12.1533 11.3822 12.1088 11.3586 12.0737 11.3237L11.425 10.675C11.3782 10.6284 11.3148 10.6023 11.2487 10.6023C11.1827 10.6023 11.1193 10.6284 11.0725 10.675L10.425 11.3225C10.39 11.3568 10.3456 11.3801 10.2975 11.3894C10.2493 11.3987 10.1995 11.3937 10.1542 11.3749C10.1089 11.3561 10.0701 11.3244 10.0427 11.2838C10.0153 11.2431 10.0004 11.1953 10 11.1462V1.75Z"
        fill="#FFC13C"
      />
    </g>
    <defs>
      <clipPath id="clip0_1254_7236">
        <rect
          width="30"
          height="30"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IconMenuCrm',
} as DefineComponent
</script>
